import { isObject } from '../is-object';
export function isSettingField(obj) {
  if (!isObject(obj)) {
    return false;
  }
  return 'isSettingField' in obj && obj.isSettingField;
}